<!-- Amex -->
<!--div *ngIf="card == 'amex'">{{ width }}, {{height}}</div-->
<svg version="1.1" viewBox="0 0 1253.4 341" *ngIf="card === 'amex'" [style.width]="cardWidth" [style.height]="cardHeight">
    <g>
        <path
            [attr.fill]="color || '#006FCF'"
            d="M1205.5,248.1h-36.7c-8.2,0-13.3-5.1-13.3-12.2c0-7.1,6.1-11.2,13.3-11.2h66.3l15.3-33.7h-81.6
			c-33.7,0-53.1,20.4-53.1,46.9c0,28.6,18.4,44.9,48,44.9h36.7c8.2,0,13.3,5.1,13.3,12.2s-5.1,12.2-13.3,12.2h-79.6V341h79.6
			c33.7,0,53.1-19.4,53.1-48C1253.4,264.5,1236.1,248.1,1205.5,248.1 M1059.6,248.1h-36.7c-8.2,0-13.3-5.1-13.3-12.2
			c0-7.1,6.1-11.2,13.3-11.2h66.3l15.3-33.7h-81.6c-33.7,0-53.1,20.4-53.1,46.9c0,28.6,18.4,44.9,48,44.9h36.7
			c8.2,0,13.3,5.1,13.3,12.2s-5.1,12.2-13.3,12.2h-79.6V341h79.6c33.7,0,53.1-19.4,53.1-48C1107.5,264.5,1090.2,248.1,1059.6,248.1"
        />
        <polygon
            [attr.fill]="color || '#006FCF'"
            points="826.9,340 952.4,340 952.4,306.3 866.7,306.3 866.7,281.8 950.4,281.8 950.4,248.1 866.7,248.1
			866.7,224.7 952.4,224.7 952.4,191 826.9,191"
        />
        <path
            [attr.fill]="color || '#006FCF'"
            d="M748.3,254.3h-41.8v-29.6h41.8c12.2,0,18.4,7.1,18.4,15.3C765.7,248.1,759.6,254.3,748.3,254.3 M806.5,239
			c0-28.6-20.4-48-53.1-48h-85.7v149h39.8v-52h14.3l44.9,52h49l-49-54.1C791.2,280.8,806.5,262.4,806.5,239 M592.2,257.3h-42.9
			v-32.7h42.9c12.2,0,18.4,7.1,18.4,16.3C609.6,250.2,603.4,257.3,592.2,257.3 M596.3,191h-86.7v149h39.8v-49h45.9
			c33.7,0,54.1-21.4,54.1-50C649.3,211.4,628.9,191,596.3,191"
        />
        <polygon
            [attr.fill]="color || '#006FCF'"
            points="502.4,191 451.4,191 412.6,235.9 373.8,191 321.8,191 387.1,264.5 320.8,340 371.8,340 411.6,293
			452.4,340 504.4,340 437.1,263.4"
        />
        <polygon
            [attr.fill]="color || '#006FCF'"
            points="189.1,340 314.7,340 314.7,306.3 228.9,306.3 228.9,281.8 312.6,281.8 312.6,248.1 228.9,248.1
			228.9,224.7 314.7,224.7 314.7,191 189.1,191"
        />
    </g>
    <g>
        <polygon
            [attr.fill]="color || '#006FCF'"
            points="1191.8,90.8 1130.6,0 1080.6,0 1080.6,149 1120.4,149 1120.4,54.1 1182.7,149 1230.6,149
			1230.6,0 1191.8,0"
        />
        <path
            [attr.fill]="color || '#006FCF'"
            d="M960.2,85.7l20.4-50l20.4,50H960.2z M956.1,0l-65.3,149h43.9l12.2-30.6h69.4l13.3,30.6h44.9L1007.1,0
			H956.1z M825.5,75.5v-3.1c0-22.4,12.2-37.8,37.8-37.8h44.9V0h-48c-49,0-74.5,31.6-74.5,72.4v3.1c0,45.9,28.6,72.4,72.4,72.4h13.3
			l16.3-33.7h-23.5C840.8,115.3,825.5,102,825.5,75.5"
        />
        <polygon [attr.fill]="color || '#006FCF'" points="725.5,0 725.5,74.5 725.5,149 744.9,149 765.3,149 765.3,74.5 765.3,0" />
        <path
            [attr.fill]="color || '#006FCF'"
            d="M645.9,63.3h-41.8V33.7h41.8c12.2,0,18.4,7.1,18.4,15.3S658.2,63.3,645.9,63.3 M704.1,48
			c0-28.6-20.4-48-53.1-48h-85.7v149h39.8v-52h14.3l44.9,52h50l-49-54.1C689.8,89.8,704.1,71.4,704.1,48"
        />
        <polygon
            [attr.fill]="color || '#006FCF'"
            points="413.3,149 538.8,149 538.8,115.3 453.1,115.3 453.1,90.8 536.7,90.8 536.7,57.1 453.1,57.1
			453.1,33.7 538.8,33.7 538.8,0 413.3,0"
        />
        <polygon
            [attr.fill]="color || '#006FCF'"
            points="286.7,93.9 253.1,0 190.8,0 190.8,149 229.6,149 229.6,41.8 268.4,149 304.1,149 343.9,41.8
			343.9,149 382.7,149 382.7,0 320.4,0"
        />
        <path [attr.fill]="color || '#006FCF'" d="M70.4,85.7l20.4-50l20.4,50H70.4z M65.3,0L0,149h43.9l12.2-30.6h69.4l13.3,30.6h44.9L117.3,0H65.3z" />
    </g>
</svg>

<!-- Discover -->
<svg version="1.1" viewBox="0 0 142.8 23.8" *ngIf="card === 'discover'" [style.width]="cardWidth" [style.height]="cardHeight">
    <defs>
        <radialGradient
            *ngIf="!color"
            [id]="'app-card-logo-discover-gradient-' + id"
            cx="67.9567"
            cy="234.0076"
            r="11.801"
            gradientTransform="matrix(1 0 0 1 6.416 -221.917)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="5.618000e-003" style="stop-color: #ffeee1" />
            <stop offset="9.664719e-002" style="stop-color: #ffead8" />
            <stop offset="0.2452" style="stop-color: #feddc2" />
            <stop offset="0.4329" style="stop-color: #fcca9f" />
            <stop offset="0.6522" style="stop-color: #f9af72" />
            <stop offset="0.8954" style="stop-color: #f68f39" />
            <stop offset="1" style="stop-color: #f48220" />
        </radialGradient>
        <radialGradient
            *ngIf="color"
            [id]="'app-card-logo-discover-gradient-' + id"
            cx="67.9567"
            cy="234.0076"
            r="11.801"
            gradientTransform="matrix(1 0 0 1 6.416 -221.917)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" [attr.stop-color]="color" [attr.stop-opacity]="0" />
            <stop offset="1" [attr.stop-color]="color" [attr.stop-opacity]="0.8" />
        </radialGradient>
    </defs>
    <g>
        <path
            [attr.fill]="'url(\'' + url + '#app-card-logo-discover-gradient-' + id + '\')'"
            d="M74.5,0.4c-6.7,0-12,5.2-12,11.4c0,6.7,5.2,11.8,12,11.8c6.7,0,11.8-5.2,11.8-11.6
			C86.3,5.4,81.2,0.4,74.5,0.4z"
        />
        <path
            [attr.fill]="color || '#091A23'"
            d="M6.6,0.9H0v22.3h6.4c3.4,0,6-0.7,8-2.6c2.4-2.1,3.9-5.4,3.9-8.6C18.5,5.4,13.5,0.9,6.6,0.9z M11.6,17.8
			c-1.3,1.3-3.2,1.7-6,1.7H4.5v-15h1.1c2.8,0,4.5,0.6,6,1.7c1.5,1.3,2.4,3.4,2.4,5.6C14.2,14.2,13.1,16.3,11.6,17.8z"
        />
        <rect x="20.6" y="0.9" [attr.fill]="color || '#091A23'" width="4.3" height="22.3" />
        <path
            [attr.fill]="color || '#091A23'"
            d="M35.8,9.5c-2.8-0.9-3.6-1.5-3.6-3c0-1.3,1.3-2.4,3.2-2.4c1.3,0,2.2,0.6,3.4,1.7l2.2-3
			c-1.9-1.7-4.1-2.4-6.7-2.4c-3.9,0-7.1,2.6-7.1,6.6c0,3,1.3,4.5,5.6,6.2c1.7,0.6,2.6,0.9,3,1.3c0.9,0.6,1.3,1.3,1.3,2.2
			c0,1.9-1.5,3.2-3.4,3.2c-2.1,0-3.7-0.9-4.7-3l-2.8,2.6c2.1,2.8,4.3,4.1,7.9,4.1c4.5,0,7.7-3,7.7-7.5C41.9,12.9,40.6,11.2,35.8,9.5z
			"
        />
        <path
            [attr.fill]="color || '#091A23'"
            d="M43.6,12c0,6.7,5.2,11.6,11.8,11.6c1.9,0,3.4-0.4,5.6-1.3V17c-1.7,1.7-3.2,2.4-5.4,2.4
			c-4.3,0-7.5-3.2-7.5-7.7c0-4.3,3.2-7.7,7.3-7.7c2.1,0,3.6,0.7,5.6,2.4V1.3C59.2,0.4,57.7,0,55.6,0C48.7,0.4,43.6,5.4,43.6,12z"
        />
        <polygon [attr.fill]="color || '#091A23'" points="96.2,15.9 90,0.9 85.4,0.9 94.9,23.8 97.3,23.8 106.9,0.9 102.4,0.9 	" />
        <polygon
            [attr.fill]="color || '#091A23'"
            points="108.9,23.2 121.5,23.2 121.5,19.5 113.4,19.5 113.4,13.3 121.1,13.3 121.1,9.7 113.4,9.7
			113.4,4.7 121.5,4.7 121.5,0.9 108.9,0.9 	"
        />
        <path
            [attr.fill]="color || '#091A23'"
            d="M138.7,7.5c0-4.1-2.8-6.7-8-6.7h-6.6V23h4.3v-9h0.6l6.2,9h5.4l-7.1-9.4C136.8,13.1,138.7,10.9,138.7,7.5z
			 M129.9,11.2h-1.3V4.3h1.3c2.6,0,4.1,1.1,4.1,3.2C134.2,9.9,132.7,11.2,129.9,11.2z"
        />
        <path
            [attr.fill]="color || '#091A23'"
            d="M141.7,2.4c0-0.4-0.2-0.6-0.7-0.6h-0.6v1.9h0.4V3l0.6,0.7h0.6L141.3,3C141.7,3,141.7,2.8,141.7,2.4z
			 M141,2.8L141,2.8V2.2l0,0c0.2,0,0.4,0,0.4,0.2C141.3,2.6,141.1,2.8,141,2.8z"
        />
        <path
            [attr.fill]="color || '#091A23'"
            d="M141.1,1.1c-0.9,0-1.7,0.7-1.7,1.7s0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7S142.1,1.1,141.1,1.1z M141.1,4.3
			c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C142.5,3.6,141.9,4.3,141.1,4.3z"
        />
    </g>
</svg>

<!-- Mastercard -->
<svg version="1.1" viewBox="0 0 67.8 52.8" *ngIf="card === 'mastercard'" [style.width]="cardWidth" [style.height]="cardHeight">
    <g transform="translate(-.07)">
        <path
            d="M66.5,52.1v0.1h0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1,0H66.5z M66.7,52
			c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0.1l0.2,0.2h-0.1l-0.2-0.2h-0.1v0.2h-0.1V52L66.7,52z
			 M66.6,52.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.1-0.1-0.1
			c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.3-0.1,0.5
			c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1C66.5,52.6,66.6,52.6,66.6,52.6 M66.6,51.7c0.1,0,0.3,0.1,0.4,0.2
			c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0
			c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.3,0-0.4c0-0.1,0.1-0.1,0.1-0.2
			c0.1-0.1,0.1-0.1,0.2-0.1C66.5,51.7,66.5,51.7,66.6,51.7 M14.7,49.7c0-0.9,0.8-1.7,1.8-1.6c0.9,0,1.7,0.8,1.6,1.8
			c0,0.9-0.8,1.6-1.7,1.6c-0.9,0-1.7-0.7-1.7-1.6C14.7,49.8,14.7,49.7,14.7,49.7 M19.2,49.7v-2.8H18v0.7c-0.4-0.5-1.1-0.8-1.8-0.8
			c-1.6,0-2.8,1.2-2.8,2.9s1.2,2.9,2.8,2.9c0.7,0,1.3-0.3,1.8-0.8v0.7h1.2V49.7z M60.1,49.7c0-0.9,0.8-1.7,1.8-1.6
			c0.9,0,1.7,0.8,1.6,1.8c0,0.9-0.8,1.6-1.7,1.6c-0.9,0-1.7-0.7-1.7-1.6C60.1,49.8,60.1,49.7,60.1,49.7 M64.6,49.7v-5h-1.2v2.9
			c-0.4-0.5-1.1-0.8-1.8-0.8c-1.6,0-2.8,1.2-2.8,2.9s1.2,2.9,2.8,2.9c0.7,0,1.3-0.3,1.8-0.8v0.7h1.2V49.7z M34.2,47.8
			c0.8,0,1.3,0.5,1.4,1.4h-2.9C32.9,48.4,33.3,47.8,34.2,47.8 M34.2,46.8c-1.6,0-2.8,1.2-2.8,2.9s1.2,2.9,2.9,2.9
			c0.8,0,1.6-0.2,2.3-0.8L36,50.9c-0.5,0.4-1,0.6-1.6,0.6c-0.8,0.1-1.6-0.5-1.7-1.4h4.1c0-0.1,0-0.3,0-0.5
			C36.9,48,35.8,46.8,34.2,46.8 M48.9,49.7c0-0.9,0.8-1.7,1.8-1.6c0.9,0,1.7,0.8,1.6,1.8c0,0.9-0.8,1.6-1.7,1.6
			c-0.9,0-1.7-0.7-1.7-1.6C48.9,49.8,48.9,49.8,48.9,49.7 M53.4,49.7v-2.8h-1.2v0.7c-0.4-0.5-1.1-0.8-1.8-0.8c-1.6,0-2.8,1.2-2.8,2.9
			s1.2,2.9,2.8,2.9c0.7,0,1.3-0.3,1.8-0.8v0.7h1.2V49.7z M42,49.7c0,1.7,1.2,2.9,3,2.9c0.7,0,1.4-0.2,2-0.7l-0.6-1
			c-0.4,0.3-0.9,0.5-1.5,0.5c-1,0-1.7-0.9-1.7-1.9c0-0.9,0.8-1.7,1.7-1.7c0.5,0,1,0.2,1.5,0.5l0.6-1c-0.6-0.5-1.3-0.7-2-0.7
			C43.2,46.8,42,48,42,49.7 M57.6,46.8c-0.6,0-1.2,0.3-1.5,0.8v-0.7H55v5.6h1.2v-3.1c0-0.9,0.4-1.4,1.2-1.4c0.3,0,0.5,0,0.8,0.1
			l0.4-1.1C58.2,46.8,57.9,46.8,57.6,46.8 M25.2,47.4c-0.7-0.4-1.5-0.6-2.3-0.6c-1.4,0-2.3,0.7-2.3,1.8c0,0.9,0.7,1.5,1.9,1.6
			l0.6,0.1c0.7,0.1,1,0.3,1,0.6c0,0.4-0.4,0.7-1.3,0.7c-0.7,0-1.3-0.2-1.9-0.6l-0.6,0.9c0.7,0.5,1.5,0.7,2.4,0.7
			c1.6,0,2.5-0.8,2.5-1.8c0-1-0.7-1.5-1.9-1.7l-0.6-0.1c-0.5-0.1-0.9-0.2-0.9-0.5c0-0.4,0.4-0.7,1.1-0.7c0.6,0,1.2,0.2,1.7,0.5
			L25.2,47.4z M40.8,46.8c-0.6,0-1.2,0.3-1.5,0.8v-0.7h-1.2v5.6h1.2v-3.1c0-0.9,0.4-1.4,1.2-1.4c0.3,0,0.5,0,0.8,0.1l0.4-1.1
			C41.3,46.8,41.1,46.8,40.8,46.8 M30.4,46.9h-2v-1.7h-1.2v1.7h-1.1V48h1.1v2.5c0,1.3,0.5,2.1,1.9,2.1c0.5,0,1.1-0.1,1.5-0.4l-0.3-1
			c-0.3,0.2-0.7,0.3-1.1,0.3c-0.6,0-0.8-0.4-0.8-0.9V48h2L30.4,46.9z M12.4,52.5V49c0.1-1.1-0.8-2.1-1.9-2.2c-0.1,0-0.2,0-0.3,0
			c-0.8-0.1-1.5,0.3-2,1c-0.4-0.6-1.1-1-1.8-1c-0.7,0-1.3,0.3-1.6,0.8v-0.7H3.5v5.6h1.2v-3.1c0-1,0.5-1.5,1.4-1.5s1.2,0.5,1.2,1.5
			v3.1h1.2v-3.1c0-1,0.6-1.5,1.4-1.5c0.8,0,1.2,0.5,1.2,1.5v3.1L12.4,52.5z"
            [attr.fill]="color || 'black'"
        />
        <path
            [attr.fill]="color || '#F79410'"
            d="M67.3,34v-0.8h-0.2l-0.2,0.6l-0.2-0.6h-0.2V34h0.1v-0.6l0.2,0.5h0.1l0.2-0.5V34H67.3z
			 M65.9,34v-0.7h0.3v-0.1h-0.7v0.1h0.3V34H65.9z"
        />
        <path
            [attr.fill]="color || '#EB001B'"
            [attr.opacity]="color ? 0.95 : 1"
            d="M26,21c0-6.4,2.9-12.5,8-16.5C24.9-2.7,11.7-1.1,4.6,8S-1,30.3,8.1,37.5c7.6,6,18.3,6,25.9,0
			C28.9,33.5,26,27.4,26,21"
        />
        <path
            [attr.fill]="color || '#FF5F00'"
            [attr.opacity]="color ? 0.85 : 1"
            d="M37.5,8c-1-1.3-2.4-2.5-3.7-3.5c-5.1,4-8.2,10-8.2,16.5v0c0,6.4,3.2,12.5,8.2,16.5
			C42.9,30.3,44.7,17.1,37.5,8z"
        />
        <path
            [attr.fill]="color || '#F79E1B'"
            [attr.opacity]="color ? 0.75 : 1"
            d="M67.9,21c0,11.6-9.4,21-21,21c-4.7,0-9.3-1.6-13-4.5c9.1-7.2,10.7-20.3,3.5-29.4
			c-1-1.3-2.2-2.5-3.5-3.5C43.1-2.7,56.3-1.1,63.4,8C66.3,11.7,67.9,16.3,67.9,21"
        />
    </g>
</svg>

<!-- Visa -->
<svg version="1.1" viewBox="0 0 365 117.9" *ngIf="card === 'visa'" [style.width]="cardWidth" [style.height]="cardHeight">
    <defs>
        <path
            [id]="'app-card-logo-visa-clip-path-' + id"
            d="M188.8,37.7c-0.2,16.4,14.6,25.6,25.8,31c11.5,5.6,15.3,9.2,15.3,14.2c-0.1,7.7-9.2,11-17.7,11.2
			c-14.8,0.2-23.4-4-30.3-7.2l-5.3,25c6.9,3.2,19.6,5.9,32.8,6.1c31,0,51.2-15.3,51.3-39c0.1-30.1-41.6-31.8-41.3-45.2
			c0.1-4.1,4-8.4,12.5-9.5c4.2-0.6,15.9-1,29.1,5.1l5.2-24.2C259.1,2.5,250,0,238.6,0C209.4,0,188.9,15.5,188.8,37.7 M316,2.1
			c-5.7,0-10.4,3.3-12.5,8.4l-44.2,105.6h31l6.2-17h37.8l3.6,17H365l-23.8-114H316 M320.3,32.9l8.9,42.8h-24.5L320.3,32.9
			 M151.2,2.1l-24.4,114h29.5l24.4-114H151.2 M107.6,2.1L76.9,79.7l-12.4-66C63,6.3,57.3,2.1,50.9,2.1H0.7L0,5.4
			c10.3,2.2,22,5.8,29.1,9.7c4.3,2.4,5.6,4.4,7,10l23.5,91h31.2l47.8-114H107.6"
        />
    </defs>
    <clipPath [id]="'app-card-logo-visa-clip-' + id">
        <use [attr.xlink:href]="'#app-card-logo-visa-clip-path-' + id" overflow="visible" />
    </clipPath>
    <linearGradient
        [id]="'app-card-logo-visa-gradient-' + id"
        gradientUnits="userSpaceOnUse"
        x1="-67.1594"
        y1="-191.0466"
        x2="-66.4265"
        y2="-191.0466"
        gradientTransform="matrix(419.708 -154.5691 154.5691 419.708 57750.2266 69917.0313)"
    >
        <stop offset="0" [style.stop-color]="color || '#222357'" />
        <stop offset="1" [style.stop-color]="color || '#254AA5'" [style.stop-opacity]="color ? 0.8 : 1" />
    </linearGradient>
    <polyline
        [attr.clip-path]="'url(\'' + url + '#app-card-logo-visa-clip-' + id + '\')'"
        [attr.fill]="'url(\'' + url + '#app-card-logo-visa-gradient-' + id + '\')'"
        points="-38.2,14.1 321.4,-118.4 403.2,103.8 43.6,236.2"
    />
</svg>

<!-- Other -->
<div *ngIf="card === 'other'" class="other" [style.font-size]="otherCardFontSize" [style.color]="color">
    <mat-icon>credit_card</mat-icon>
</div>
